const state = {
    token: sessionStorage.getItem("token") || null,
    code: sessionStorage.getItem("code") || null,
}

export default state